export default __webpack_public_path__ + "static/media/CV_BODY.25d1e88f.pdf";